import Styles from './LeaveWorkspaceModal.module.scss'

import { LeaveWorkspaceModalProps } from './Types'
import { Button } from 'components/Button'
import { Modal } from 'almanac-ui/Modal'
import { Loader } from 'components/Loader/Loader'
import { useLeaveWorkspace } from './useLeaveWorkspace'

const LeaveWorkspaceModal = ({ workspace, onLeave, close }: LeaveWorkspaceModalProps) => {
  const { leaveWorkspace, leaveWorkspaceLoading } = useLeaveWorkspace({ workspace, onLeave, close })

  return (
    <Modal.Root>
      <Modal.Header title={`Leave ${workspace.name}?`} />
      <Modal.Content>
        {leaveWorkspaceLoading ? (
          <div className={Styles.loading} data-testid="loading">
            <Loader />
          </div>
        ) : (
          'If you leave, you will lose access to your files in this workspace. Are you sure you want to leave?'
        )}
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Button size="xl" onPress={leaveWorkspace} isDisabled={leaveWorkspaceLoading ?? false}>
            Leave
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export { LeaveWorkspaceModal }
